import { createAction, props } from "@ngrx/store";
import { IEmployee, ICreateUserRequest, IUpdateUserRequest } from "src/app/company/models/employee";

// Get HTEC Employees
export const getHtecEmployees = createAction(
    '[Employees] Get Htec Employees'
);

export const getHtecEmployeesSuccess = createAction(
    '[Employees] Get Htec Employees success', 
    props<{ htecEmployees: IEmployee[] }>()
);

export const getHtecEmployeesFailure = createAction(
    '[Employees] Get Htec Employees failure',
    props<{error: string}>()
);

// Get Employees
export const getEmployees = createAction(
    '[Employees] Get Employees'
);

export const getEmployeesSuccess = createAction(
    '[Employees] Get Employees success', 
    props<{ employees: IEmployee[] }>()
);

export const getEmployeesFailure = createAction(
    '[Employees] Get Employees failure',
    props<{error: string}>()
);

// Get Current Employee
export const getCurrentEmployee = createAction(
    '[Employee] Get Current Employee'
);

export const getCurrentEmployeeSuccess = createAction(
    '[Employee] Get Current Employee success', 
    props<{ employee: IEmployee }>()
);

export const getCurrentEmployeeFailure = createAction(
    '[Employee] Get Current Employee failure',
    props<{error: string}>()
);

// Get Employee by id
export const getEmployeeById = createAction(
    '[Employee] Get Employee by id ',
    props<{id: string}>()
);

export const getEmployeeByIdSuccess = createAction(
    '[Employee] Get Employee by id success', 
    props<{ device: IEmployee }>()
);

export const getEmployeeByIdFailure = createAction(
    '[Employee] Get Employee by id failure',
    props<{error: string}>()
);

// Create Employees
export const createEmployee = createAction(
    '[Employees] Create Employee',
    props<{ employee: ICreateUserRequest }>()
);

export const createEmployeeSuccess = createAction(
    '[Employees] Create Employee success',
    props<{ employee: IEmployee }>()
);

export const createEmployeeFailure = createAction(
    '[Employees] Create Employee failure',
    props<{error: string}>()
);

// Update Employees 
export const updateEmployee = createAction(
    '[Employees] Update Employee',
    props<{ employee: IUpdateUserRequest }>()
);

export const updateEmployeeSuccess = createAction(
    '[Employees] Update Employee success',
    props<{ employee: IEmployee }>()
);

export const updateEmployeeFailure = createAction(
    '[Employees] Update Employee failure',
    props<{error: string}>()
);

// Delete Employees 
export const deleteEmployee = createAction(
    '[Employees] Delete Employee',
    props<{id: string}>()
);

export const deleteEmployeeSuccess = createAction(
    '[Employees] Delete Employee success',
    props<{id: string}>()
);

export const deleteEmployeeFailure = createAction(
    '[Employees] Delete Employee failure',
    props<{error: string}>()
);